import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { withAreaGetter } from 'providers/AreasConsumers';
import { areas } from 'constants/areas';
import ExchangeRateListBrowser from './ExchangeRateListBrowser';
import Portal from 'utils/portal/Portal';
import HeaderLinks from './header/HeaderLinks';
import HeaderTitle from './header/HeaderTitle';
import { ADMIN_EXCHANGE_RATES } from 'constants/rightsCodes';
import PermissionCheck from 'components/common/PermissionCheck';

const Route = ({ getElemByAreaKey }) => {
  const [canImportExchangeRate, setCanImportExchangeRate] = useState(true);

  const handleCanImportExchangeRate = value => {
    setCanImportExchangeRate(value);
  };

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <HeaderTitle />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_EXCHANGE_RATES} withForbiddenPage={false}>
          <HeaderLinks handleCanImportExchangeRate={handleCanImportExchangeRate} canImportExchangeRate={canImportExchangeRate} />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_EXCHANGE_RATES}>
        <ExchangeRateListBrowser handleCanImportExchangeRate={handleCanImportExchangeRate} />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
